/**
 * CopilotFab — floating AI Copilot launcher for detail screens.
 *
 * Detail screens (attendee / session / paper) don't render the BottomNav, so
 * the copilot — and its context-aware agentic actions (Draft follow-up, Plan
 * review time, …) — would otherwise be unreachable there. This drops the same
 * AICopilotModal onto those screens via a floating button. The modal detects
 * the current entity from the route, so the right actions appear automatically.
 */
import { useState } from 'react';
import { Sparkles } from 'lucide-react';
import { AICopilotModal } from './AICopilotModal';
import { useEventModules } from '../hooks/useEventModules';

export function CopilotFab() {
  const [open, setOpen] = useState(false);
  const { isEnabled, labelFor } = useEventModules();
  if (!isEnabled('ai_copilot')) return null;

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        aria-label={labelFor('ai_copilot')}
        className="absolute right-5 z-30 size-14 rounded-full flex items-center justify-center active:scale-90 transition-transform"
        style={{
          bottom: 'calc(1.5rem + env(safe-area-inset-bottom, 0px))',
          backgroundColor: 'var(--app-accent-solid)',
          boxShadow: '0 0 28px var(--app-accent-glow)',
        }}
      >
        <Sparkles className="w-6 h-6 text-white" />
      </button>
      <AICopilotModal isOpen={open} onClose={() => setOpen(false)} />
    </>
  );
}
